import React from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import cn from 'classnames';

import Socials from 'src/components/common/Socials';
import { ROOT, SHARE_ROUTE } from 'src/constants/routes';
import { OG } from 'src/constants/other';
import * as analytics from 'src/utils/analytics';

import iconShare from './assets/icon-share.svg';
import iconLeft from './assets/icon-arrow-left.svg';
import makoLogo from './assets/mako-logo.svg';
import css from './Header.module.scss';
import { useAppContext } from 'src/context/AppContext';

const MAKO_HOME_URL = 'https://www.mako.co.il';

const texts = {
  backBtn: `חפשו מחדש`,
};

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { personalStats } = useAppContext();
  const isResultsRoute = Boolean(matchPath(SHARE_ROUTE, location.pathname));

  const onBackBtnClick = () => {
    analytics.onReSearchClick();
    navigate(ROOT);
  };

  const onMobileShareClick = () => {
    if (navigator.share) {
      const isResultsShare = isResultsRoute && personalStats?.stats.percentage !== undefined;

      navigator
        .share({
          title: isResultsShare ? OG.resultsPage.title(personalStats.stats.percentage) : OG.mainPage.title,
          text: isResultsShare ? OG.resultsPage.description : OG.mainPage.description,
          url: window.location.href,
        })
        .then(() => console.log('Share successful'))
        .catch((error) => console.error('Share failed:', error));
    } else {
      console.warn('Web Share API not supported');
    }
  };

  return (
    <header className={cn(css.header, isResultsRoute && css.resultsPage)}>
      <button className={css.mobileShareBtn} onClick={onMobileShareClick}>
        <img src={iconShare} />
      </button>
      <a className={css.logo} href={MAKO_HOME_URL} aria-label="mako">
        <img src={makoLogo} alt="" />
      </a>
      {isResultsRoute ? (
        <button className={css.backBtn} onClick={onBackBtnClick}>
          <span>{texts.backBtn}</span>
          <img src={iconLeft} />
        </button>
      ) : (
        <Socials className={css.socials} type="general" />
      )}
    </header>
  );
};

export default Header;
